export enum AnalyticsAction {
  // To Do
  NewNoteClicked = 'New note clicked',

  // Partner Program
  NavigateToPartnerProgramPage = 'Navigate to partner program page',

  // Notifications
  LoadNotifications = 'Load notifications',

  // Firm Settings
  OpenFirmSettingsDialog = 'Open firm settings dialog',
  FirmSettingsTabs = 'Firm settings tabs',

  // Client
  ClientTabs = 'Client tabs',
  AdvisoryToolActivated = 'Advisory Tool Activated',
  AdvisoryToolDeactivated = 'Advisory Tool Deactivated',

  // Main Navigation Menu
  MainNavigationMenuToggled = 'Menu toggled',
}
